class CollectionLoadMore extends window.HTMLElement {
  constructor() {
    super();
    this.currentPage = 1;
    this.isLoading = false;
    this.sectionId = null;
  }
  connectedCallback() {
    this.productsList = this.querySelector(".products-list");
    this.loadMoreButton = this.querySelector(".load-more-button");
    this.loadingState = this.querySelector(".btn-spinner");
    this.buttonText = this.querySelector(".btn-text");
    this.errorMessage = this.querySelector(".error-message");
    const section = this.closest('[id^="shopify-section-"]');
    if (section) {
      this.sectionId = section.id.replace("shopify-section-", "");
    }
    this.collectionHandle = this.dataset.collectionId;
    this.productsPerPage = parseInt(this.dataset.productsPerPage) || 24;
    this.totalProducts = parseInt(this.dataset.totalProducts) || 0;
    const currentProductsCount = this.productsList?.children.length || 0;
    this.currentPage = Math.floor(currentProductsCount / this.productsPerPage) || 1;
    if (currentProductsCount >= this.totalProducts) {
      this.hideLoadMoreButton();
    }
    if (this.loadMoreButton) {
      this.loadMoreButton.addEventListener("click", this.handleLoadMore.bind(this));
    }
    this.scrollKey = "collection-scroll:" + location.pathname;
    let scrollTimer;
    this.scrollHandler = () => {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(() => {
        sessionStorage.setItem(this.scrollKey, window.scrollY);
      }, 150);
    };
    window.addEventListener("scroll", this.scrollHandler);
    const urlPage = parseInt(new URL(window.location.href).searchParams.get("page"));
    if (urlPage > 1 && urlPage > this.currentPage) {
      this.restorePages(urlPage);
    }
  }
  async restorePages(targetPage) {
    while (this.currentPage < targetPage && this.productsList.children.length < this.totalProducts) {
      await this.handleLoadMore();
    }
    const savedY = parseInt(sessionStorage.getItem(this.scrollKey));
    if (savedY) {
      requestAnimationFrame(() => window.scrollTo(0, savedY));
      sessionStorage.removeItem(this.scrollKey);
    }
  }
  async handleLoadMore() {
    if (this.isLoading || !this.sectionId) return;
    this.setLoadingState(true);
    this.hideError();
    try {
      this.currentPage++;
      const url = this.buildSectionUrl();
      const response = await fetch(url, {
        headers: {
          "X-Requested-With": "XMLHttpRequest"
        }
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const newProductsList = doc.querySelector(".products-list");
      if (newProductsList && newProductsList.children.length > 0) {
        Array.from(newProductsList.children).forEach((child) => {
          this.productsList.appendChild(child);
        });
        const pageUrl = new URL(window.location.href);
        pageUrl.searchParams.set("page", this.currentPage);
        window.history.replaceState({ source: "swup", url: pageUrl.pathname + pageUrl.search }, "", pageUrl.toString());
        const loadedProductsCount = this.productsList.children.length;
        if (loadedProductsCount >= this.totalProducts) {
          this.hideLoadMoreButton();
        }
      } else {
        this.hideLoadMoreButton();
      }
    } catch (error) {
      console.error("Error loading more products:", error);
      this.showError();
      this.currentPage--;
    } finally {
      this.setLoadingState(false);
    }
  }
  buildSectionUrl() {
    const url = new URL(window.location.href);
    url.searchParams.set("page", this.currentPage);
    url.searchParams.set("section_id", this.sectionId);
    url.hash = "";
    return url.toString();
  }
  setLoadingState(loading) {
    this.isLoading = loading;
    if (this.loadMoreButton) {
      this.loadMoreButton.disabled = loading;
    }
    if (this.buttonText && this.loadingState) {
      if (loading) {
        this.buttonText.classList.add("hidden");
        this.loadingState.classList.remove("hidden");
      } else {
        this.buttonText.classList.remove("hidden");
        this.loadingState.classList.add("hidden");
      }
    }
  }
  hideLoadMoreButton() {
    const container = this.querySelector(".load-more-container");
    if (container) {
      container.style.display = "none";
    }
  }
  showLoadMoreButton() {
    const container = this.querySelector(".load-more-container");
    if (container) {
      container.style.display = "block";
    }
  }
  showError() {
    if (this.errorMessage) {
      this.errorMessage.classList.remove("hidden");
    }
  }
  hideError() {
    if (this.errorMessage) {
      this.errorMessage.classList.add("hidden");
    }
  }
  /**
   * Reset the component state (called when filters change)
   */
  reset() {
    this.currentPage = 1;
    this.isLoading = false;
    this.hideError();
    const currentProductsCount = this.productsList?.children.length || 0;
    this.currentPage = Math.ceil(currentProductsCount / this.productsPerPage);
    if (currentProductsCount < this.totalProducts) {
      this.showLoadMoreButton();
    } else {
      this.hideLoadMoreButton();
    }
  }
  /**
   * Update total products count (called when filters change)
   */
  updateTotalProducts(total) {
    this.totalProducts = parseInt(total) || 0;
    this.dataset.totalProducts = this.totalProducts;
    const currentProductsCount = this.productsList?.children.length || 0;
    if (currentProductsCount >= this.totalProducts) {
      this.hideLoadMoreButton();
    } else {
      this.showLoadMoreButton();
    }
  }
}
window.customElements.define("collection-load-more", CollectionLoadMore);
export {
  CollectionLoadMore as default
};
